import styles from "./Footer.module.scss";
import Text from "../Typography/Text/Text";
import logo from "../../static/images/logo.svg";
import telegram from "../../static/images/telegram_icon.svg";
import youtube from "../../static/images/youtube_icon.svg";
import vk from "../../static/images/vk_icon.svg";
import odnoklassniki from "../../static/images/odnoklassniki_icon.svg";
import backsparkLogo from "../../static/images/backspark__logo.svg";

export default function Footer() {
  return (
    <div className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.logo}>
          <a href="https://ch-sk.ru/">
            <img src={logo} alt="" />
          </a>
        </div>
        <div className={styles.content}>
          <div className={styles.icons}>
            <div className={styles.icon}>
              <a href="https://t.me/chuvesk">
                <img src={telegram} alt="" />
              </a>
            </div>

            <div className={styles.icon}>
              <a href="https://www.youtube.com/channel/UC6VgyfcAknZ0pTYcjciMBeQ">
                <img src={youtube} alt="" />
              </a>
            </div>
            <div className={styles.icon}>
              <a href="https://vk.com/ch_esk">
                <img src={vk} alt="" />
              </a>
            </div>
            <div className={styles.icon}>
              <a href="https://ok.ru/group/52115161022617">
                <img src={odnoklassniki} alt="" />
              </a>
            </div>
          </div>
          <div className={styles.info}>
            <div className={styles.hotline}>
              <a href="tel:+78002000742">
                <div className={styles.hotline__item}>
                  <Text size="base">Горячая линия</Text>
                </div>
                <div className={styles.hotline__item}>
                  <Text size="base">8-800-2000-742</Text>
                </div>
              </a>
            </div>
            <div className={styles.madeBy}>
              <div className={styles.text}>Made by</div>
              <div className={styles.backsparkLogo}>
                <img src={backsparkLogo} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
